import { lazy } from 'react';
import { authModules } from 'app/auth';
import ABSUtils from '@abs/utils/ABSUtils';
import themesConfig from 'app/configs/themesConfig';

const Overview = lazy(() => import('./Overview'));

const OverviewConfig = {
	settings: {
		layout: {
			config: {}
		},
		theme: {
			main: ABSUtils.IsDarkMode() ? themesConfig.persomatDark : themesConfig.persomat,
			navbar: ABSUtils.IsDarkMode() ? themesConfig.persomatDark : themesConfig.persomat,
		}
	},
	routes: [
		{
			path: '/pm/overview',
			element: <Overview />,
			auth: authModules.pm_default
		}
	]
};

export default OverviewConfig;
